export const bannerCodeOnline = {
    JW6UWK: 'W036',
    JW6UWL: 'W036',
    JW6UWM: 'W036',
    SUSFAX: '',
    JWABWJ: 'W034',
    JWABWH: 'W034',
    JWABWC: 'W035',
    JWBBWJ: 'W034',
    JWBBWC: 'W034',
    JWEBWJ: 'W034',
    JWEBWC: 'W034',
    JWEBWH: 'W034',
    JWAFWJ: 'W034',
    JWAFWH: 'W034',
    JWAFWC: 'W034',
    JWBFWJ: 'W034',
    JWBFWC: 'W034',
    JWEFWJ: 'W034',
    JWEFWC: 'W034',
    JWEFWH: 'W034',
    JW6BWJ: 'W034',
    JWCCWJ: 'W035',
    JWCCWH: 'W035',
    JWA9WG: 'W035',
    JWA9WH: 'W035',
    JWA9WI: 'W035',
    JWA9WJ: 'W035',
    JWACWC: 'W035',
    JWACWG: 'W035',
    JWACWH: 'W035',
    JWACWI: 'W035',
    JWCGWJ: 'W035',
    JWCGWH: 'W035',
    JWEKWG: 'W035',
    JWEKWH: 'W035',
    JWEKWI: 'W035',
    JWEKWJ: 'W035',
    JWELWC: 'W035',
    JWELWG: 'W035',
    JWELWH: 'W035',
    JWELWI: 'W035',
    JWCGWI: 'W035',
    JWAPWJ: 'W035',
    JWAPWH: 'W035',
    JW5AWN: 'W035',
    JW5BWN: 'W035',
    JWA8WG: 'W035',
    JW6BWK: 'W035',
    JW6BWL: 'W035',
    JWAOWH: 'W035',
    JW6AWQ: 'W035',
    JW6BWH: 'W035',
    JWCCWC: 'W045',
    JWBBWH: 'W045',
    JWCGWC: 'W045',
    JWBFWH: 'W045',
    JW5LWL: 'W045',
    JW2WW1: 'W045',
    JWAPWI: 'W045',
    JWBCWG: 'W035',
    JW4AWA: 'W034',
    JW4BWA: 'W034',
    JW1EW1: 'W034',
    JW1EW2: 'W034',
    JW2FW1: 'W034',
    JWCBWJ: 'W034',
    JWCBWC: 'W034',
    JWCBWH: 'W034',
    JW5LW4: 'W034',
    JW5LW2: 'W034',
    JW1FW1: 'W034',
    JW1FW2: 'W034',
    JW5LW3: 'W034',
    JW5LW1: 'W034',
    JW5LWW: 'W034',
    JW2BW1: 'W034',
    JW2FW2: 'W034',
    JW2FW6: 'W034',
    JW2FW9: 'W034',
    JW5LW5: 'W034',
    JWCFWJ: 'W034',
    JWCFWC: 'W034',
    JWCFWH: 'W034',
    JW1GW1: 'W034',
    JW1GW2: 'W034',
    JW2CW2: 'W034',
    JW3LW1: 'W034',
    JW8DW9: 'W034',
    JW4AWB: 'W034',
    JW4BWB: 'W034',
    JWECWG: 'W035',
    JWBGWG: 'W035',
    JWEGWG: 'W035',
    JWBCWJ: 'W035',
    JWACWJ: 'W035',
    JW5AWF: 'W035',
    JWFCWC: 'W035',
    JWFCWG: 'W035',
    JWFCWH: 'W035',
    JWFCWI: 'W035',
    JWFCWJ: 'W035',
    JWFGWC: 'W035',
    JWFGWG: 'W035',
    JWFGWH: 'W035',
    JWFGWI: 'W035',
    JWFGWJ: 'W035',
    JWFHWC: 'W035',
    JWFHWG: 'W035',
    JWFHWH: 'W035',
    JWFHWI: 'W035',
    JWFHWJ: 'W035',
    JWFIWC: 'W035',
    JWFIWG: 'W035',
    JWFIWH: 'W035',
    JWFIWI: 'W035',
    JWFIWJ: 'W035',
    JWGCWC: 'W035',
    JWGCWG: 'W035',
    JWGCWH: 'W035',
    JWGCWI: 'W035',
    JWGCWJ: 'W035',
    JWGGWC: 'W035',
    JWGGWG: 'W035',
    JWGGWH: 'W035',
    JWGGWI: 'W035',
    JWGGWJ: 'W035',
    JWGHWC: 'W035',
    JWGHWG: 'W035',
    JWGHWH: 'W035',
    JWGHWI: 'W035',
    JWGHWJ: 'W035',
    JWGIWC: 'W035',
    JWGIWG: 'W035',
    JWGIWH: 'W035',
    JWGIWI: 'W035',
    JWGIWJ: 'W035',
    JWHCWC: 'W035',
    JWHCWG: 'W035',
    JWHCWH: 'W035',
    JWHCWI: 'W035',
    JWHCWJ: 'W035',
    JWHGWC: 'W035',
    JWHGWG: 'W035',
    JWHGWH: 'W035',
    JWHGWI: 'W035',
    JWHGWJ: 'W035',
    JWHHWC: 'W035',
    JWHHWG: 'W035',
    JWHHWH: 'W035',
    JWHHWI: 'W035',
    JWHHWJ: 'W035',
    JWHIWC: 'W035',
    JWHIWG: 'W035',
    JWHIWH: 'W035',
    JWHIWI: 'W035',
    JWHIWJ: 'W035',
    JW0KW1: 'W035',
    JW2BW2: 'W035',
    JW2DW1: 'W036',
    JW2FW4: 'W035',
    JW2FW7: 'W035',
    JW2FWA: 'W035',
    JW2FWB: 'W035',
    JW2GW1: 'W035',
    JW2GW2: 'W035',
    JW2GW3: 'W035',
    JW2GW4: 'W035',
    JW2GW5: 'W035',
    JW2GW6: 'W035',
    JW2GW7: 'W035',
    JW2JW1: 'W035',
    JW2JW2: 'W035',
    JW2JW3: 'W035',
    JW2JW4: 'W035',
    JW2JW5: 'W035',
    JW2JW6: 'W035',
    JW2JW7: 'W035',
    JW2JW8: 'W035',
    JW2JW9: 'W035',
    JW2JWA: 'W035',
    JW2KW1: 'W035',
    JW2KW2: 'W035',
    JW2KW4: 'W035',
    JW2KW5: 'W035',
    JW2KW7: 'W035',
    JW2KW8: 'W035',
    JW2KW9: 'W035',
    JW2KWB: 'W035',
    JW2KWC: 'W035',
    JW2KWD: 'W036',
    JW2KWE: 'W035',
    JW2KWG: 'W035',
    JW2KWH: 'W035',
    JW2KWK: 'W035',
    JW2NW1: 'W035',
    JW2NW2: 'W035',
    JW2NW3: 'W035',
    JW2PW1: 'W035',
    JW2PW2: 'W035',
    JW2PW3: 'W035',
    JW2PW4: 'W035',
    JW2QW1: 'W035',
    JW2QW2: 'W035',
    JW2QW3: 'W035',
    JW2QW4: 'W035',
    JW2SW1: 'W035',
    JW4LW1: 'W035',
    JW5AWA: 'W035',
    JW5AWB: 'W035',
    JW5AWC: 'W035',
    JW5AWD: 'W035',
    JW5AWE: 'W035',
    JW5AWG: 'W035',
    JW5AWH: 'W035',
    JW5AWJ: 'W035',
    JW5AWK: 'W035',
    JW5AWL: 'W035',
    JW5AWM: 'W035',
    JW5AWP: 'W035',
    JW5AWZ: 'W035',
    JW5BWA: 'W035',
    JW5BWB: 'W035',
    JW5BWC: 'W035',
    JW5BWD: 'W035',
    JW5BWE: 'W035',
    JW5BWF: 'W035',
    JW5BWG: 'W035',
    JW5BWH: 'W035',
    JW5BWJ: 'W035',
    JW5BWK: 'W035',
    JW5BWL: 'W035',
    JW5BWM: 'W035',
    JW5BWP: 'W035',
    JW5BWZ: 'W035',
    JW5LW6: 'W035',
    JW5LW7: 'W035',
    JW5LW8: 'W035',
    JW5LW9: 'W035',
    JW5LWA: 'W035',
    JW5LWB: 'W035',
    JW5LWC: 'W035',
    JW5LWD: 'W035',
    JW5LWE: 'W035',
    JW5LWF: 'W035',
    JW5LWG: 'W035',
    JW5LWH: 'W035',
    JW5LWJ: 'W035',
    JW5LWK: 'W035',
    JW5LWM: 'W035',
    JW5LWN: 'W035',
    JW5LWP: 'W035',
    JW5LWQ: 'W035',
    JW5LWT: 'W035',
    JW5LWU: 'W035',
    JW5LWV: 'W035',
    JW6AWD: 'W035',
    JW6BWQ: 'W035',
    JW6CWQ: 'W035',
    JWAEW9: 'W035',
    JWAEWC: 'W035',
    JWAEWG: 'W035',
    JWAEWH: 'W035',
    JWAEWI: 'W035',
    JWAEWJ: 'W035',
    JWAGWC: 'W035',
    JWAGWG: 'W035',
    JWAGWH: 'W035',
    JWAGWI: 'W035',
    JWAGWJ: 'W035',
    JWAHWC: 'W035',
    JWAHWG: 'W035',
    JWAHWH: 'W035',
    JWAHWI: 'W035',
    JWAHWJ: 'W035',
    JWAIWC: 'W035',
    JWAIWG: 'W035',
    JWAIWH: 'W035',
    JWAIWI: 'W035',
    JWAIWJ: 'W035',
    JWAJWG: 'W035',
    JWAJWH: 'W035',
    JWAJWI: 'W035',
    JWAJWJ: 'W035',
    JWAKWG: 'W035',
    JWAKWH: 'W035',
    JWAKWI: 'W035',
    JWAKWJ: 'W035',
    JWALWC: 'W035',
    JWALWG: 'W035',
    JWALWH: 'W035',
    JWALWI: 'W035',
    JWALWJ: 'W035',
    JWAMWJ: 'W035',
    JWAMWH: 'W035',
    JWAMWI: 'W035',
    JWAMWG: 'W035',
    JWANWG: 'W035',
    JWANWH: 'W035',
    JWANWI: 'W035',
    JWANWJ: 'W035',
    JWAOWC: 'W035',
    JWAOWG: 'W035',
    JWAOWI: 'W035',
    JWAOWJ: 'W035',
    JWAPWG: 'W035',
    JWAQWJ: 'W035',
    JWAQWG: 'W035',
    JWAQWH: 'W035',
    JWAQWI: 'W035',
    JWARWG: 'W035',
    JWARWH: 'W035',
    JWARWI: 'W035',
    JWARWJ: 'W035',
    JWB9WG: 'W035',
    JWB9WH: 'W035',
    JWB9WI: 'W035',
    JWB9WJ: 'W035',
    JWBCWC: 'W035',
    JWBCWH: 'W035',
    JWBCWI: 'W035',
    JWBEWC: 'W035',
    JWBEWG: 'W035',
    JWBEWH: 'W035',
    JWBEWI: 'W035',
    JWBEWJ: 'W035',
    JWBGWC: 'W035',
    JWBGWH: 'W035',
    JWBGWI: 'W035',
    JWBGWJ: 'W035',
    JWBHWC: 'W035',
    JWBHWG: 'W035',
    JWBHWH: 'W035',
    JWBHWI: 'W035',
    JWBHWJ: 'W035',
    JWBIWC: 'W035',
    JWBIWG: 'W035',
    JWBIWH: 'W035',
    JWBIWI: 'W035',
    JWBIWJ: 'W035',
    JWBJWG: 'W035',
    JWBJWH: 'W035',
    JWBJWI: 'W035',
    JWBJWJ: 'W035',
    JWBKWG: 'W035',
    JWBKWH: 'W035',
    JWBKWI: 'W035',
    JWBKWJ: 'W035',
    JWBLWC: 'W035',
    JWBLWG: 'W035',
    JWBLWH: 'W035',
    JWBLWI: 'W035',
    JWBLWJ: 'W035',
    JWBMWG: 'W035',
    JWBMWH: 'W035',
    JWBMWI: 'W035',
    JWBMWJ: 'W035',
    JWBNWG: 'W035',
    JWBNWH: 'W035',
    JWBNWI: 'W035',
    JWBNWJ: 'W035',
    JWBOWC: 'W035',
    JWBOWG: 'W035',
    JWBOWH: 'W035',
    JWBOWI: 'W035',
    JWBOWJ: 'W035',
    JWBPWG: 'W035',
    JWBPWH: 'W035',
    JWBPWI: 'W035',
    JWBPWJ: 'W035',
    JWBQWG: 'W035',
    JWBQWH: 'W035',
    JWBQWI: 'W035',
    JWBQWJ: 'W035',
    JWBRWG: 'W035',
    JWBRWH: 'W035',
    JWBRWI: 'W035',
    JWBRWJ: 'W035',
    JWC9WG: 'W035',
    JWC9WH: 'W035',
    JWC9WI: 'W035',
    JWC9WJ: 'W035',
    JWCCWG: 'W035',
    JWCCWI: 'W035',
    JWCEWC: 'W035',
    JWCEWG: 'W035',
    JWCEWH: 'W035',
    JWCEWI: 'W035',
    JWCEWJ: 'W035',
    JWCGWG: 'W035',
    JWCHWC: 'W035',
    JWCHWG: 'W035',
    JWCHWH: 'W035',
    JWCHWI: 'W035',
    JWCHWJ: 'W035',
    JWCIWC: 'W035',
    JWCIWG: 'W035',
    JWCIWH: 'W035',
    JWCIWI: 'W035',
    JWCIWJ: 'W035',
    JWCJWG: 'W035',
    JWCJWH: 'W035',
    JWCJWI: 'W035',
    JWCJWJ: 'W035',
    JWCKWG: 'W035',
    JWCKWH: 'W035',
    JWCKWI: 'W035',
    JWCKWJ: 'W035',
    JWCLWC: 'W035',
    JWCLWG: 'W035',
    JWCLWH: 'W035',
    JWCLWI: 'W035',
    JWCLWJ: 'W035',
    JWCMWG: 'W035',
    JWCMWH: 'W035',
    JWCMWI: 'W035',
    JWCMWJ: 'W035',
    JWCNWG: 'W035',
    JWCNWH: 'W035',
    JWCNWI: 'W035',
    JWCNWJ: 'W035',
    JWCOWC: 'W035',
    JWCOWG: 'W035',
    JWCOWH: 'W035',
    JWCOWI: 'W035',
    JWCOWJ: 'W035',
    JWCPWG: 'W035',
    JWCPWH: 'W035',
    JWCPWI: 'W035',
    JWCPWJ: 'W035',
    JWCQWG: 'W035',
    JWCQWH: 'W035',
    JWCQWI: 'W035',
    JWCQWJ: 'W035',
    JWCRWG: 'W035',
    JWCRWH: 'W035',
    JWCRWI: 'W035',
    JWCRWJ: 'W035',
    JWE9WG: 'W035',
    JWE9WH: 'W035',
    JWE9WI: 'W035',
    JWE9WJ: 'W035',
    JWECWC: 'W035',
    JWECWH: 'W035',
    JWECWI: 'W035',
    JWECWJ: 'W035',
    JWEEWC: 'W035',
    JWEEWG: 'W035',
    JWEEWH: 'W035',
    JWEEWI: 'W035',
    JWEEWJ: 'W035',
    JWEGWC: 'W035',
    JWEGWH: 'W035',
    JWEGWI: 'W035',
    JWEGWJ: 'W035',
    JWEHWC: 'W035',
    JWEHWG: 'W035',
    JWEHWH: 'W035',
    JWEHWI: 'W035',
    JWEHWJ: 'W035',
    JWEIWC: 'W035',
    JWEIWG: 'W035',
    JWEIWH: 'W035',
    JWEIWI: 'W035',
    JWEIWJ: 'W035',
    JWEJWG: 'W035',
    JWEJWH: 'W035',
    JWEJWI: 'W035',
    JWEJWJ: 'W035',
    JWELWJ: 'W035',
    JWEMWG: 'W035',
    JWEMWH: 'W035',
    JWEMWI: 'W035',
    JWEMWJ: 'W035',
    JWENWG: 'W035',
    JWENWH: 'W035',
    JWENWI: 'W035',
    JWENWJ: 'W035',
    JWEOWC: 'W035',
    JWEOWG: 'W035',
    JWEOWH: 'W035',
    JWEOWI: 'W035',
    JWEOWJ: 'W035',
    JWEPWG: 'W035',
    JWEPWH: 'W035',
    JWEPWI: 'W035',
    JWEPWJ: 'W035',
    JWEQWG: 'W035',
    JWEQWH: 'W035',
    JWEQWI: 'W035',
    JWEQWJ: 'W035',
    JWERWG: 'W035',
    JWERWH: 'W035',
    JWERWI: 'W035',
    JWERWJ: 'W035',
    JW2AW1: 'W036',
    JW5LWS: 'W036',
    JW6VWN: 'W036',
    JW6AWG: 'W036',
    JW2WW2: 'W036',
    JW6AWE: 'W036',
    JW6AWF: 'W036',
    JW6DWQ: 'W036',
    JW6AWA: 'W036',
    JW6AWB: 'W036',
    JW6AWC: 'W036',
    JW6BWM: 'W036',
    JW0RW9: 'W036',
    JW2AW2: 'W036',
    JW2CW1: 'W036',
    JW2CW3: 'W036',
    JW2CW4: 'W036',
    JW2CW5: 'W036',
    JW2CW6: 'W036',
    JW2CW7: 'W036',
    JW2CW8: 'W036',
    JW2FW3: 'W036',
    JW2FW5: 'W036',
    JW2FW8: 'W036',
    JW2TW1: 'W036',
    JW2WW3: 'W036',
    JW4LW3: 'W036',
    JW5LWR: 'W036',
    JW5SW9: 'W036',
    JW6WWJ: 'W036',
    JW8DWG: 'W036',
    JW8DWK: 'W036',
    JW8VW9: 'W036',
    JW8VWS: 'W036',
    JW9VW9: 'W036',
    JW9VWN: 'W036',
    JWJ1W1: 'W036',
    JWJ1W2: 'W036',
    JWJ1W3: 'W036',
    JWJ1W4: 'W036',
    JW0NW1: 'W035',
    JW0NWK: 'W035',
    JW0YW1: 'W035',
    JW0YW3: 'W035',
    JW2AW3: 'W035',
    JW2KW3: 'W035',
    JW2KW6: 'W035',
    JW2KWA: 'W035',
    JW2KWF: 'W035',
    JW2KWJ: 'W035',
    JW2KWL: 'W035',
    JW2NW4: 'W035',
    JW2TW2: 'W035',
    JW4LW2: 'W035',
    JW4LW4: 'W035',
    JW6BWN: 'W035',
    JW6BWP: 'W035',
    JW9VWS: 'W035',
    JWALW9: 'W035',
    JW74W1: 'W037',
    JW74W2: 'W037',
    JW74WA: 'W037',
    JW84W3: 'W037',
    JW84W4: 'W037',
    JW84W5: 'W037',
    JW84WB: 'W037',
    JW84WC: 'W037',
    JW84WD: 'W037',
    JW98W1: 'W037',
    JW98W2: 'W037',
    JW98WA: 'W037',
    JW99W3: 'W037',
    JW99W7: 'W037',
    JW99WB: 'W037',
    JWI0W1: 'W040',
    JWI0W2: 'W040',
    JWI0WA: 'W040',
    JWI9W2: 'W040',
    JWI9W3: 'W040',
    JWI9W7: 'W040',
    JWI9WA: 'W040',
    JWI9WB: 'W040',
    JWIAW1: 'W040',
    JWIAW2: 'W040',
    JWIAWA: 'W040',
    JWI9W8: 'W040',
    JWA7WT: 'W036',
    JWAAWF: 'W036',
    JWAAWT: 'W036',
    JWABWF: 'W036',
    JWADWT: 'W036',
    JWAEWE: 'W036',
    JWAEWF: 'W036',
    JWAEWT: 'W036',
    JWAFWE: 'W036',
    JWAFWF: 'W036',
    JWAFWT: 'W036',
    JWAIWF: 'W036',
    JWANWT: 'W036',
    JWAPWF: 'W036',
    JWATWT: 'W036',
    JWAUWT: 'W036',
    JWAVWT: 'W036',
    JWAWWT: 'W036',
    JWCAWF: 'W036',
    JWCAWT: 'W036',
    JWCBWF: 'W036',
    JWCCWE: 'W036',
    JWCCWF: 'W036',
    JWCCWT: 'W036',
    JWCFWE: 'W036',
    JWCFWF: 'W036',
    JWCGWT: 'W036',
    JWCNWT: 'W036',
    JWCPWF: 'W036',
    JWCSWT: 'W036',
    JWCUWT: 'W036',
    JWYYWY: 'W036',
    JWU00P: 'W036',
    LWU00P: 'W036',
    JW71W1: 'W036',
    JW71W2: 'W036',
    JW71WA: 'W036',
    JW72W1: 'W036',
    JW72W2: 'W036',
    JW72WA: 'W036',
    JW73W1: 'W036',
    JW73W2: 'W036',
    JW73W6: 'W036',
    JW73WA: 'W036',
    JW75W1: 'W036',
    JW75W2: 'W036',
    JW75WA: 'W036',
    JW76W1: 'W036',
    JW76W2: 'W036',
    JW76WA: 'W036',
    JW77W1: 'W036',
    JW77W2: 'W036',
    JW77W6: 'W036',
    JW77WA: 'W036',
    JW8CW2: 'W036',
    JW8CWA: 'W036',
    JW81W3: 'W036',
    JW81W4: 'W036',
    JW81W5: 'W036',
    JW81WB: 'W036',
    JW81WC: 'W036',
    JW81WD: 'W036',
    JW82W3: 'W036',
    JW82W4: 'W036',
    JW82W5: 'W036',
    JW82WB: 'W036',
    JW82WC: 'W036',
    JW82WD: 'W036',
    JW83W3: 'W036',
    JW83W4: 'W036',
    JW83W5: 'W036',
    JW83WB: 'W036',
    JW83WC: 'W036',
    JW83WD: 'W036',
    JW83WZ: 'W036',
    JW85W3: 'W036',
    JW85W4: 'W036',
    JW85W5: 'W036',
    JW85WB: 'W036',
    JW85WC: 'W036',
    JW85WD: 'W036',
    JW86W3: 'W036',
    JW86W4: 'W036',
    JW86W5: 'W036',
    JW86WB: 'W036',
    JW86WC: 'W036',
    JW86WD: 'W036',
    JW87W3: 'W036',
    JW87W4: 'W036',
    JW87W5: 'W036',
    JW87WB: 'W036',
    JW87WC: 'W036',
    JW87WD: 'W036',
    JW87WZ: 'W036',
    JW8BWF: 'W036'
    }
